export default __webpack_public_path__ + "static/media/girl2.688b0167.png";